import { render, staticRenderFns } from "./FanTile.vue?vue&type=template&id=12fddeea&"
import script from "./FanTile.vue?vue&type=script&lang=js&"
export * from "./FanTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports